import React, { useState } from 'react';

const AdminDashboard = ({
    onLogout,
    onCourseManagement,
    onChapterManagement,
    onQuestionBank,
    onStudentDirectory,
    onParentDirectory,
    onRevenue
}) => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
        document.documentElement.classList.toggle('dark');
    };

    return (
        <>
            <style>
                {`
                .material-symbols-outlined {
                    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
                    vertical-align: middle;
                    display: inline-block;
                    line-height: 1;
                    text-transform: none;
                    letter-spacing: normal;
                    word-wrap: normal;
                    white-space: nowrap;
                    direction: ltr;
                }
                ::-webkit-scrollbar {
                    width: 5px;
                }
                ::-webkit-scrollbar-track {
                    background: transparent;
                }
                ::-webkit-scrollbar-thumb {
                    background: rgba(203, 213, 225, 0.5);
                    border-radius: 10px;
                }
                .dark ::-webkit-scrollbar-thumb {
                    background: rgba(51, 65, 85, 0.5);
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: rgba(148, 163, 184, 0.8);
                }
                .dark ::-webkit-scrollbar-thumb:hover {
                    background: rgba(71, 85, 105, 0.8);
                }
                scrollbar-width: thin;
                scrollbar-color: rgba(203, 213, 225, 0.5) transparent;
                `}
            </style>

            <div className={`fixed inset-0 flex overflow-hidden font-sans antialiased ${isDarkMode ? 'dark bg-[#0F172A] text-slate-100' : 'bg-[#F8FAFC] text-slate-900'}`}>
                {/* Sidebar */}
                <aside className="w-64 bg-[#131C2E] text-slate-300 flex-shrink-0 flex flex-col border-r border-slate-800 hidden lg:flex h-full">
                    <div className="p-6 flex items-center gap-3 shrink-0">
                        <div className="w-10 h-10 bg-[#00A669] rounded-lg flex items-center justify-center text-white font-bold text-xl uppercase tracking-tighter shadow-lg shadow-emerald-500/20">H</div>
                        <div>
                            <h1 className="text-white font-bold leading-tight">Master Admin</h1>
                            <p className="text-[10px] text-slate-500 uppercase tracking-widest font-semibold text-nowrap">System Management</p>
                        </div>
                    </div>

                    <nav className="flex-1 px-4 space-y-1 mt-4 overflow-y-auto custom-scrollbar">
                        <button className="w-full bg-[#00A669] text-white flex items-center gap-3 px-4 py-3 rounded-xl transition-all shadow-md shadow-emerald-500/20 text-left">
                            <span className="material-symbols-outlined shrink-0 text-xl">dashboard</span>
                            <span className="font-medium">Dashboard Overview</span>
                        </button>

                        <div className="pt-4 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Core Content</div>
                        <button
                            onClick={onCourseManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">auto_stories</span>
                            <span className="font-medium group-hover:text-white transition-colors">Course Management</span>
                        </button>
                        <button
                            onClick={onChapterManagement}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">account_tree</span>
                            <span className="font-medium group-hover:text-white transition-colors">Chapter Management</span>
                        </button>
                        <button
                            onClick={onQuestionBank}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">quiz</span>
                            <span className="font-medium group-hover:text-white transition-colors">Question Bank</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Directories</div>
                        <button
                            onClick={onStudentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">group</span>
                            <span className="font-medium group-hover:text-white transition-colors">Student Directory</span>
                        </button>
                        <button
                            onClick={onParentDirectory}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">family_restroom</span>
                            <span className="font-medium group-hover:text-white transition-colors">Parent Directory</span>
                        </button>

                        <div className="pt-6 pb-2 px-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Reports</div>
                        <button
                            onClick={onRevenue}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl hover:bg-slate-800/50 transition-all group text-left"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl group-hover:text-white transition-colors">monitoring</span>
                            <span className="font-medium group-hover:text-white transition-colors">Revenue/Analytics</span>
                        </button>

                    </nav>

                    <div className="p-4 mt-auto border-t border-slate-800 shrink-0">
                        <button
                            onClick={onLogout}
                            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-rose-400 hover:bg-rose-500/10 transition-all group"
                        >
                            <span className="material-symbols-outlined shrink-0 text-xl">logout</span>
                            <span className="font-medium group-hover:translate-x-1 transition-transform">Sign Out</span>
                        </button>
                    </div>
                </aside>

                {/* Main Content Area */}
                <div className="flex-1 flex flex-col min-w-0 h-full overflow-hidden">
                    {/* Header */}
                    <header className="h-16 bg-white dark:bg-[#1E293B] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-8 sticky top-0 z-20 shrink-0 shadow-sm">
                        <div className="flex-1 max-w-xl">
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
                                <input
                                    className="w-full bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg pl-10 pr-4 py-2 focus:ring-[#00A669] focus:border-[#00A669] transition-all text-sm outline-none text-slate-700 dark:text-slate-200"
                                    placeholder="Search data, reports, users..."
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="flex items-center gap-6 ml-6">
                            <button className="relative text-slate-500 dark:text-slate-400 hover:text-[#00A669] transition-colors flex items-center">
                                <span className="material-symbols-outlined">notifications</span>
                                <span className="absolute top-0 right-0 w-2 h-2 bg-rose-500 rounded-full border-2 border-white dark:border-[#1E293B]"></span>
                            </button>
                            <div className="h-8 w-[1px] bg-slate-200 dark:bg-slate-700"></div>
                            <div className="flex items-center gap-3">
                                <div className="text-right hidden sm:block">
                                    <p className="text-sm font-semibold dark:text-white">Admin Profile</p>
                                    <p className="text-[10px] text-slate-500 font-bold uppercase tracking-tight">Super Administrator</p>
                                </div>
                                <div className="w-10 h-10 rounded-full bg-slate-100 dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 overflow-hidden shadow-sm">
                                    <img alt="Admin Avatar" className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuB_RLrWS6EwBazBnSQG5_DHFfXALJfYg9wsfMW2fPBEUgyM8X72ZCm3tlqpialTVYycHghgR294Gsrna7Md-Y9BvMy9mxyIOvqFuj8_YHzdBVxVI2U40W2yQq21BtKRTS6sIsuf-Yp954VMbmBsiyidj0IifV9SqpurFlj0TzEkyVoievlPd5qy98srI15ENSq6h760WxEMEp8ZODu-efso3LH0phGIQADhqq71tFNmvHA8-ImYHsI7eorpZHeD2nlfdjDp1fPs5MM" />
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Scrollable Content */}
                    <main className="flex-1 overflow-y-auto p-8 space-y-8 bg-background-light dark:bg-[#0F172A] pb-24">
                        {/* Welcome Message */}
                        <div>
                            <h2 className="text-2xl font-bold tracking-tight dark:text-white">Dashboard Overview</h2>
                            <p className="text-slate-500 dark:text-slate-400 text-sm">Welcome back! Here's what's happening across the platform today.</p>
                        </div>

                        {/* Stats Cards */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            <div className="bg-white dark:bg-[#1E293B] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm transition-all hover:shadow-md">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-[#00A669]/10 flex items-center justify-center text-[#00A669]">
                                        <span className="material-symbols-outlined">group</span>
                                    </div>
                                    <div className="flex items-center gap-1 text-emerald-500 font-bold text-xs bg-emerald-50 dark:bg-emerald-500/10 px-2 py-1 rounded-full">
                                        <span className="material-symbols-outlined text-[14px]">trending_up</span>
                                        +12.5%
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <p className="text-slate-500 dark:text-slate-400 text-[10px] font-bold uppercase tracking-wider">Total Students</p>
                                    <h3 className="text-2xl font-bold dark:text-white">24,512</h3>
                                </div>
                            </div>
                            <div className="bg-white dark:bg-[#1E293B] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm transition-all hover:shadow-md">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center text-blue-500">
                                        <span className="material-symbols-outlined">auto_stories</span>
                                    </div>
                                    <div className="flex items-center gap-1 text-emerald-500 font-bold text-xs bg-emerald-50 dark:bg-emerald-500/10 px-2 py-1 rounded-full">
                                        <span className="material-symbols-outlined text-[14px]">trending_up</span>
                                        +4
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <p className="text-slate-500 dark:text-slate-400 text-[10px] font-bold uppercase tracking-wider">Active Courses</p>
                                    <h3 className="text-2xl font-bold dark:text-white">142</h3>
                                </div>
                            </div>
                            <div className="bg-white dark:bg-[#1E293B] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm transition-all hover:shadow-md">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center text-emerald-600">
                                        <span className="material-symbols-outlined">payments</span>
                                    </div>
                                    <div className="flex items-center gap-1 text-emerald-500 font-bold text-xs bg-emerald-50 dark:bg-emerald-500/10 px-2 py-1 rounded-full">
                                        <span className="material-symbols-outlined text-[14px]">trending_up</span>
                                        +8.2%
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <p className="text-slate-500 dark:text-slate-400 text-[10px] font-bold uppercase tracking-wider">Total Revenue</p>
                                    <h3 className="text-2xl font-bold dark:text-white">$1.24M</h3>
                                </div>
                            </div>
                            <div className="bg-white dark:bg-[#1E293B] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm transition-all hover:shadow-md">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="w-12 h-12 rounded-xl bg-amber-500/10 flex items-center justify-center text-amber-600">
                                        <span className="material-symbols-outlined">quiz</span>
                                    </div>
                                    <div className="flex items-center gap-1 text-rose-500 font-bold text-xs bg-rose-50 dark:bg-rose-500/10 px-2 py-1 rounded-full">
                                        <span className="material-symbols-outlined text-[14px]">trending_up</span>
                                        +12
                                    </div>
                                </div>
                                <div className="space-y-1">
                                    <p className="text-slate-500 dark:text-slate-400 text-[10px] font-bold uppercase tracking-wider">Pending Questions</p>
                                    <h3 className="text-2xl font-bold dark:text-white">85</h3>
                                </div>
                            </div>
                        </div>

                        {/* Analytics Section */}
                        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                            <div className="lg:col-span-2 bg-white dark:bg-[#1E293B] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
                                <div className="flex items-center justify-between mb-8">
                                    <div>
                                        <h4 className="text-lg font-bold dark:text-white">Enrollment Analytics</h4>
                                        <p className="text-xs text-slate-500">Student registration trends over the last 6 months</p>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-2">
                                            <div className="w-3 h-3 rounded-full bg-[#00A669]"></div>
                                            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Curriculum</span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                                            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Competitive</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="h-64 flex items-end justify-between gap-4 px-2 pt-4">
                                    {[
                                        { month: 'Jan', v1: 32, v2: 24 },
                                        { month: 'Feb', v1: 40, v2: 28 },
                                        { month: 'Mar', v1: 48, v2: 36 },
                                        { month: 'Apr', v1: 44, v2: 32 },
                                        { month: 'May', v1: 56, v2: 44 },
                                        { month: 'Jun', v1: 60, v2: 48 },
                                    ].map((item, idx) => (
                                        <div key={idx} className="flex-1 flex flex-col items-center gap-2 group h-full">
                                            <div className="w-full flex justify-center gap-1.5 h-full items-end pb-2">
                                                <div
                                                    className="w-3 bg-[#00A669]/20 hover:bg-[#00A669] transition-all rounded-t-sm"
                                                    style={{ height: `${item.v1 * 3}px` }}
                                                ></div>
                                                <div
                                                    className="w-3 bg-blue-500/20 hover:bg-blue-500 transition-all rounded-t-sm"
                                                    style={{ height: `${item.v2 * 3}px` }}
                                                ></div>
                                            </div>
                                            <span className="text-[10px] text-slate-400 font-bold uppercase">{item.month}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="bg-white dark:bg-[#1E293B] p-6 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
                                <h4 className="text-lg font-bold dark:text-white mb-8">Revenue Distribution</h4>
                                <div className="relative w-48 h-48 mx-auto mb-8">
                                    <svg className="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
                                        <circle className="text-slate-100 dark:text-slate-800" cx="18" cy="18" fill="none" r="15.915" stroke="currentColor" strokeWidth="4"></circle>
                                        <circle className="text-[#00A669]" cx="18" cy="18" fill="none" r="15.915" stroke="currentColor" strokeDasharray="65 35" strokeDashoffset="0" strokeWidth="4"></circle>
                                        <circle className="text-blue-500" cx="18" cy="18" fill="none" r="15.915" stroke="currentColor" strokeDasharray="35 65" strokeDashoffset="-65" strokeWidth="4"></circle>
                                    </svg>
                                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                                        <span className="text-2xl font-bold dark:text-white text-center leading-none">100%</span>
                                        <span className="text-[10px] text-slate-500 font-bold uppercase mt-1">Total Income</span>
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <div className="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                        <div className="flex items-center gap-2">
                                            <div className="w-3 h-3 rounded-sm bg-[#00A669]"></div>
                                            <span className="text-sm font-medium text-slate-600 dark:text-slate-400">Curriculum</span>
                                        </div>
                                        <span className="text-sm font-bold dark:text-white">65%</span>
                                    </div>
                                    <div className="flex items-center justify-between p-2 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                        <div className="flex items-center gap-2">
                                            <div className="w-3 h-3 rounded-sm bg-blue-500"></div>
                                            <span className="text-sm font-medium text-slate-600 dark:text-slate-400">Competitive</span>
                                        </div>
                                        <span className="text-sm font-bold dark:text-white">35%</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Activity Table */}
                        <div className="bg-white dark:bg-[#1E293B] rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm overflow-hidden min-h-[400px]">
                            <div className="px-6 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
                                <h4 className="text-lg font-bold dark:text-white">Recent System Activity</h4>
                                <button className="text-[10px] font-bold text-[#00A669] hover:underline uppercase tracking-widest bg-emerald-50 dark:bg-emerald-500/10 px-3 py-1.5 rounded-lg transition-colors">View All Logs</button>
                            </div>
                            <div className="overflow-x-auto">
                                <table className="w-full text-left border-collapse min-w-[600px]">
                                    <thead>
                                        <tr className="bg-slate-50/50 dark:bg-slate-800/50 border-b border-slate-100 dark:border-slate-800">
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">Action</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest">User / Entity</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest text-center">Status</th>
                                            <th className="px-6 py-4 text-[10px] font-bold text-slate-500 uppercase tracking-widest text-right">Timestamp</th>
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
                                        {[
                                            { action: 'New course published', entity: 'JEE Advanced Physics 2024', status: 'Success', time: '2 mins ago', icon: 'publish', color: 'emerald' },
                                            { action: 'User reported a bug', entity: 'Student #9421 (Arjun V.)', status: 'Pending', time: '15 mins ago', icon: 'bug_report', color: 'rose' },
                                            { action: 'New student signup', entity: 'priya.sharma@email.com', status: 'Verified', time: '42 mins ago', icon: 'person_add', color: 'blue' },
                                            { action: 'System backup completed', entity: 'Automated Weekly Task', status: 'System', time: '2 hours ago', icon: 'settings', color: 'slate' },
                                        ].map((row, idx) => (
                                            <tr key={idx} className="hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors group">
                                                <td className="px-6 py-4">
                                                    <div className="flex items-center gap-3">
                                                        <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${row.color === 'emerald' ? 'bg-emerald-100 text-emerald-600 dark:bg-emerald-500/10' :
                                                            row.color === 'rose' ? 'bg-rose-100 text-rose-600 dark:bg-rose-500/10' :
                                                                row.color === 'blue' ? 'bg-blue-100 text-blue-600 dark:bg-blue-500/10' :
                                                                    'bg-slate-100 text-slate-600 dark:bg-slate-800'
                                                            }`}>
                                                            <span className="material-symbols-outlined text-sm">{row.icon}</span>
                                                        </div>
                                                        <span className="font-medium text-sm text-slate-900 dark:text-white group-hover:text-[#00A669] transition-colors">{row.action}</span>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 text-xs text-slate-600 dark:text-slate-400">{row.entity}</td>
                                                <td className="px-6 py-4 text-center">
                                                    <span className={`px-2 py-0.5 text-[10px] font-bold uppercase border rounded-full ${row.color === 'emerald' ? 'bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-500/10 dark:border-emerald-500/20' :
                                                        row.color === 'rose' ? 'bg-rose-50 text-rose-600 border-rose-100 dark:bg-rose-500/10 dark:border-rose-500/20' :
                                                            row.color === 'blue' ? 'bg-blue-50 text-blue-600 border-blue-100 dark:bg-blue-500/10 dark:border-blue-500/20' :
                                                                'bg-slate-50 text-slate-600 border-slate-200 dark:bg-slate-800'
                                                        }`}>
                                                        {row.status}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 text-right text-[10px] text-slate-500 font-medium">{row.time}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Footer */}
                        <footer className="py-8 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between text-slate-400 text-[10px] font-bold uppercase tracking-widest gap-4">
                            <div className="flex items-center gap-2">
                                <div className="w-6 h-6 bg-[#00A669] rounded flex items-center justify-center text-white text-[10px] font-bold">H</div>
                                <span>© 2024 Himigo Platform - Master Admin Console</span>
                            </div>
                        </footer>
                    </main>
                </div>

                {/* Dark Mode Toggle Float */}
                <button
                    onClick={toggleDarkMode}
                    className="fixed bottom-6 right-6 w-12 h-12 rounded-full bg-white dark:bg-[#1E293B] border border-slate-200 dark:border-slate-700 shadow-xl shadow-slate-200/50 dark:shadow-none flex items-center justify-center text-slate-600 dark:text-slate-300 z-[60] hover:scale-110 active:scale-95 transition-all"
                >
                    <span className="material-symbols-outlined">{isDarkMode ? 'light_mode' : 'dark_mode'}</span>
                </button>
            </div>
        </>
    );
};

export default AdminDashboard;
